import React from 'react'
import { Skeleton, Stack } from '@mui/material'

/**
 * Skeleton placeholder matching the ProductCard layout. Rendered while the
 * catalogue query is still loading.
 */
export const ProductCardSkeleton: React.FC = () => {
  return (
    <Stack gap={1.2} sx={{ padding: 1.2 }}>

      <Skeleton
        variant="rectangular"
        width="100%"
        height="18rem"
        sx={{ borderRadius: '0.8rem' }}
      />

      <Stack gap={0.6}>

        <Skeleton variant="text" width="70%" height="2.4rem" />

        <Skeleton variant="text" width="90%" height="1.6rem" />

        <Skeleton variant="text" width="60%" height="1.6rem" />

      </Stack>

      <Stack direction="row" justifyContent="space-between" alignItems="center">

        <Skeleton variant="text" width="6rem" height="2rem" />

        <Skeleton variant="rounded" width="11rem" height="3.2rem" sx={{ borderRadius: '40px' }} />

      </Stack>

    </Stack>
  )
}
